/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchInteractionAction } from './SearchInteractionAction';
import {
    SearchInteractionActionFromJSON,
    SearchInteractionActionFromJSONTyped,
    SearchInteractionActionToJSON,
    SearchInteractionActionToJSONTyped,
} from './SearchInteractionAction';
import type { SuggestedSearchType } from './SuggestedSearchType';
import {
    SuggestedSearchTypeFromJSON,
    SuggestedSearchTypeFromJSONTyped,
    SuggestedSearchTypeToJSON,
    SuggestedSearchTypeToJSONTyped,
} from './SuggestedSearchType';

/**
 * 
 * @export
 * @interface SearchInteractionEvent
 */
export interface SearchInteractionEvent {
    /**
     * 
     * @type {string}
     * @memberof SearchInteractionEvent
     */
    searchSessionId: string;
    /**
     * 
     * @type {number}
     * @memberof SearchInteractionEvent
     */
    vervotechPropertyId: number;
    /**
     * 
     * @type {SearchInteractionAction}
     * @memberof SearchInteractionEvent
     */
    action: SearchInteractionAction;
    /**
     * 
     * @type {number}
     * @memberof SearchInteractionEvent
     */
    forYouScoreAtTime?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchInteractionEvent
     */
    positionInResults?: number | null;
    /**
     * Client environment (e.g. production, development, preview)
     * @type {string}
     * @memberof SearchInteractionEvent
     */
    environment?: string | null;
    /**
     * 
     * @type {SuggestedSearchType}
     * @memberof SearchInteractionEvent
     */
    suggestedSearchContext?: SuggestedSearchType;
}



/**
 * Check if a given object implements the SearchInteractionEvent interface.
 */
export function instanceOfSearchInteractionEvent(value: object): value is SearchInteractionEvent {
    if (!('searchSessionId' in value) || value['searchSessionId'] === undefined) return false;
    if (!('vervotechPropertyId' in value) || value['vervotechPropertyId'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function SearchInteractionEventFromJSON(json: any): SearchInteractionEvent {
    return SearchInteractionEventFromJSONTyped(json, false);
}

export function SearchInteractionEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchInteractionEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'searchSessionId': json['search_session_id'],
        'vervotechPropertyId': json['vervotech_property_id'],
        'action': SearchInteractionActionFromJSON(json['action']),
        'forYouScoreAtTime': json['for_you_score_at_time'] == null ? undefined : json['for_you_score_at_time'],
        'positionInResults': json['position_in_results'] == null ? undefined : json['position_in_results'],
        'environment': json['environment'] == null ? undefined : json['environment'],
        'suggestedSearchContext': json['suggested_search_context'] == null ? undefined : SuggestedSearchTypeFromJSON(json['suggested_search_context']),
    };
}

export function SearchInteractionEventToJSON(json: any): SearchInteractionEvent {
    return SearchInteractionEventToJSONTyped(json, false);
}

export function SearchInteractionEventToJSONTyped(value?: SearchInteractionEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'search_session_id': value['searchSessionId'],
        'vervotech_property_id': value['vervotechPropertyId'],
        'action': SearchInteractionActionToJSON(value['action']),
        'for_you_score_at_time': value['forYouScoreAtTime'],
        'position_in_results': value['positionInResults'],
        'environment': value['environment'],
        'suggested_search_context': SuggestedSearchTypeToJSON(value['suggestedSearchContext']),
    };
}

